import { useEffect } from "react";

type SeoProps = {
  title: string;
  description: string;
  path: string;
};

export function Seo({ title, description, path }: SeoProps) {
  useEffect(() => {
    document.title = title;
    const descriptionTag = document.querySelector<HTMLMetaElement>('meta[name="description"]');
    descriptionTag?.setAttribute("content", description);

    let canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = `https://doraflix.site${path}`;
  }, [description, path, title]);

  return null;
}
